const applicationReviewerKPIs = [
    {
        "uuid": "1",
        "reviewer": "審查委員A",
        "appQuantity": 8,
        "totalSentTimes": 10,
        "timeComplianceRate": 100,
    },
    {
        "uuid": "2",
        "reviewer": "審查委員B",
        "appQuantity": 25,
        "totalSentTimes": 30,
        "timeComplianceRate": 85,
    },
    {
        "uuid": "3",
        "reviewer": "審查委員C",
        "appQuantity": 16,
        "totalSentTimes": 16,
        "timeComplianceRate": 70,
    },
]

export default applicationReviewerKPIs;